import { render, staticRenderFns } from "./shops-list.vue?vue&type=template&id=b900e9ae&scoped=true&"
import script from "./shops-list.vue?vue&type=script&lang=js&"
export * from "./shops-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b900e9ae",
  null
  
)

export default component.exports